/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { MenuItemMapPriceEntity } from '../model/menuItemMapPriceEntity';
import { SmartDineResponseMenuItemMapPriceEntity } from '../model/smartDineResponseMenuItemMapPriceEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class MenuItemMapPriceRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapPriceEntity>;
    public createMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapPriceEntity>>;
    public createMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapPriceEntity>>;
    public createMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createMenuItemMapPrice.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling createMenuItemMapPrice.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling createMenuItemMapPrice.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling createMenuItemMapPrice.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseMenuItemMapPriceEntity>('post',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/prices`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param menuItemMapPriceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapPriceEntity>;
    public deleteMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapPriceEntity>>;
    public deleteMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapPriceEntity>>;
    public deleteMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling deleteMenuItemMapPrice.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling deleteMenuItemMapPrice.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling deleteMenuItemMapPrice.');
        }

        if (menuItemMapPriceId === null || menuItemMapPriceId === undefined) {
            throw new Error('Required parameter menuItemMapPriceId was null or undefined when calling deleteMenuItemMapPrice.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseMenuItemMapPriceEntity>('delete',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/prices/${encodeURIComponent(String(menuItemMapPriceId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param menuItemMapPriceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapPriceEntity>;
    public getMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapPriceEntity>>;
    public getMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapPriceEntity>>;
    public getMenuItemMapPrice(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getMenuItemMapPrice.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getMenuItemMapPrice.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling getMenuItemMapPrice.');
        }

        if (menuItemMapPriceId === null || menuItemMapPriceId === undefined) {
            throw new Error('Required parameter menuItemMapPriceId was null or undefined when calling getMenuItemMapPrice.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseMenuItemMapPriceEntity>('get',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/prices/${encodeURIComponent(String(menuItemMapPriceId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMenuItemMapPrices(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapPriceEntity>;
    public getMenuItemMapPrices(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapPriceEntity>>;
    public getMenuItemMapPrices(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapPriceEntity>>;
    public getMenuItemMapPrices(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getMenuItemMapPrices.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getMenuItemMapPrices.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling getMenuItemMapPrices.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseMenuItemMapPriceEntity>('get',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/prices`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param menuItemMapPriceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapPriceEntity>;
    public updateMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapPriceEntity>>;
    public updateMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapPriceEntity>>;
    public updateMenuItemMapPrice(body: MenuItemMapPriceEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapPriceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateMenuItemMapPrice.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling updateMenuItemMapPrice.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling updateMenuItemMapPrice.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling updateMenuItemMapPrice.');
        }

        if (menuItemMapPriceId === null || menuItemMapPriceId === undefined) {
            throw new Error('Required parameter menuItemMapPriceId was null or undefined when calling updateMenuItemMapPrice.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseMenuItemMapPriceEntity>('put',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/prices/${encodeURIComponent(String(menuItemMapPriceId))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
